@if (message) {
  <div class="success">
    <i class="material-icons success-icon">check_circle</i>
    <span>{{ message }}</span>
  </div>
}
